import { createBrowserRouter, Navigate } from 'react-router-dom';

// project-imports
import UserRoutes from './UserRoutes';
import NavigationRoutes from './NavigationRoutes';
import AuthRoutes from './AuthRoutes';
import ErrorPage from '../views/Error';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    NavigationRoutes, 
    UserRoutes, 
    AuthRoutes,
    { path: '*', element: <ErrorPage /> }
  ],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME || '/',
  }
);

export default router;
